import type { FONTS } from 'vars/typography'

import { styled } from '@linaria/react'

export const CounterWrapper = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`
export const CounterSC = styled.svg<{
  duration: number
  strokeDashArray: number
}>`
  height: 100%;
  width: 100%;

  path#progress {
    --strokeDashValue: ${({ strokeDashArray }) => strokeDashArray};
    stroke-dasharray: var(--strokeDashValue);
    stroke-dashoffset: 0;
    animation-name: timer;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    animation-duration: ${({ duration }) => `${duration}s`};
    transform: rotate(90deg);
    transform-origin: 50% 50%;
    @keyframes timer {
      from {
        stroke-dashoffset: 0;
      }
      to {
        stroke-dashoffset: var(--strokeDashValue);
      }
    }
  }
`

export const ProgressValueSC = styled.text<{ font: FONTS }>`
  font: ${({ font }) => `var(${font})`};
`
